<template lang="pug">
v-container(fluid fill-height class=" ")
  div(
    class="tw-bg-white tw-h-full tw-overflow-hidden tw-px-0 tw-border tw-border-gray-lighten-2 tw-shadow-md tw-pt-0 tw-rounded-md"
  )
    v-row(no-gutters class="tw-h-full d-flex flex-row flex-grow-1")
      v-col(class=" d-flex flex-column flex-grow-1 min-h-0 fill-height overflow-hidden")
        v-row(no-gutters align="center" class=" flex-grow-0 flex-shrink-1 tw-h-10 tw-bg-gray-lighten-4 tw-pl-2")
          v-col
            v-icon(small color="red") mdi-circle
            v-icon(small color="yellow darken-2" class="px-1") mdi-circle
            v-icon(small color="green") mdi-circle
        v-row(no-gutters class=" d-flex flex-column flex-grow-1 tw-max-h-full flex-shrink-0 tw-min-h-0 tw-overflow-hidden ")
          v-col(class=" flex-grow-1  d-flex overflow-auto flex-column flex-shrink-0 min-h-0 tw-overflow-hidden ")
            div(class="tw-relative tw-w-full tw-max-w-full tw-h-full overflow-hidden tw-overflow-hidden tw-mb-0")
              router-view(:key="theme + key" class="tw-overflow-hidden")
</template>
<script>
export default {
  data() {
    return {
      key: 1,
    };
  },
  computed: {
    theme() {
      return this.$store.getters['website/theme'];
    },
    website() {
      return this.$store.getters['website/website'];
    },
  },
  async mounted() {
    this.$store.commit('displaySidebar', false);
    this.$store.commit('displayMainToolbar', false);
    this.$store.commit('displayWebsiteToolbar', true);
    await this.$store
      .dispatch('website/get')
      .then((response) => {
        this.key++;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
</script>
